import axios from 'axios';

const URL_Test = process.env.REACT_APP_SERVER_URL;
const URL = process.env.REACT_APP_SERVER_URL_TEST;
const mediaURL_test = process.env.REACT_APP_MEDIA_URL;
const mediaURL = process.env.REACT_APP_MEDIA_URL_TEST;
const PyURL = process.env.REACT_APP_PY_URL;

const getMediaURL = () => `${sessionStorage.getItem('isTest') !== 'Yes' ? mediaURL : mediaURL_test}/getFiles`;
const previewMediaURL = () => `${sessionStorage.getItem('isTest') !== 'Yes' ? mediaURL : mediaURL_test}/preview`;

export const getMethodFun = async (endPoint) =>
    await axios.get(`${sessionStorage.getItem('isTest') !== 'Yes' ? URL : URL_Test}/${endPoint}`);

export const postMethodFun = async (formData, endPoint, config = {}) =>
    await axios.post(`${sessionStorage.getItem('isTest') !== 'Yes' ? URL : URL_Test}/${endPoint}`, formData, config);
export const postMethodFun2 = async (formData, endPoint) =>
    await axios.post(`${sessionStorage.getItem('isTest') !== 'Yes' ? URL : URL_Test}/${endPoint}`, formData, { transformResponse: null });
export const postMethodFun3 = async (formData, endPoint, config = {}) => await axios.post(`${URL_Test}/${endPoint}`, formData, config);
export const mediaUpload = async (formData, progress) => {
    const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (data) => {
            progress(data.progress * 100);
        }
    };
    const postMediaURL = `${sessionStorage.getItem('isTest') !== 'Yes' ? mediaURL : mediaURL_test}/uploadFile`;
    let response = await axios.post(postMediaURL, formData, config);
    return response;
};

export const getMethodPy = async (endPoint) => await axios.get(`${PyURL}/${endPoint}`);

export const postMediaPy = async (endPoint, formData, progress) => {
    const config = {
        headers: { 'Content-Type': 'multipart/form-data' },
        onUploadProgress: (data) => {
            progress(data.progress * 100);
        }
    };
    let response = await axios.post(`${PyURL}/${endPoint}`, formData, config);
    return response;
};

export const postSaveDraft = async (formData, config = {}) =>
    await axios.post(`${sessionStorage.getItem('isTest') !== 'Yes' ? URL : URL_Test}/drafts/upsert`, formData, config);

export const getDraft = async (formData) =>
    await axios.post(`${sessionStorage.getItem('isTest') !== 'Yes' ? URL : URL_Test}/drafts/formId`, formData);

export const deleteDraft = async (formData) =>
    await axios.post(`${sessionStorage.getItem('isTest') !== 'Yes' ? URL : URL_Test}/drafts/deleteformId`, formData);

const MediaURL = { preview: previewMediaURL, get: getMediaURL };

export default MediaURL;
